import React, { useState } from 'react';
import './SingInButton.css';
import { useNavigate } from 'react-router-dom';

function SignInButton({ onSignIn }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleRoleClick = () => {
    onSignIn();
    navigate(`/login?role=user`);
    setOpen(false);
  };

  const handleRoleClickAdmin = () => {
    onSignIn();
    navigate(`/loginadmin?role=administrator`);
    setOpen(false);
  };

  const handleRoleClickSadmin = () => {
    onSignIn();
    navigate(`/loginsadmin?role=superadmin`);
    setOpen(false);
  };

  return (
    <div className="signin-container">
      <button className="lbtn" onClick={() => setOpen(!open)}>Sign In ▾</button>
      {open && (
        <div className="dropdown">
          <button onClick={handleRoleClick}>👤 User</button>
          <button onClick={handleRoleClickAdmin}>🛠 Administrator</button>
          <button onClick={handleRoleClickSadmin}>🛡 Super Admin</button>
        </div>
      )}
    </div>
  );
}

  

export default SignInButton;
